import React from 'react';

const Pitch = () => {
  return (
    <div className="pitch-wrapper" id='pitch'>
      <div className="title">
        <h2>Is your web presence working for you?</h2>
        <div className="line"></div>
      </div>
      <div className="pitch">
        <p>
          If someone needs what you provide, will your website draw them in? <br />
          What will they see if they are on their phone? A responsive &
          accessible web presence is no longer merely a 'bonus' or 'nice to
          have' - it is essential.
        </p>
        <p>
          It is my privilege to offer a chance to be seen on the web to small
          businesses and individuals around me. Whether that be creating a
          website for you from the ground up, or updating an existing presence
          for the mobile age. Providing a place for interested parties to find
          and learn about what you offer is what I offer. How can I help you
          today?
        </p>
      </div>
    </div>
  );
};

export default Pitch;
